// Module
var code = "<p>Разрешения владельца определяют кто распоряжается аккаунтом. Владельцы могут переписывать все ключи и менять любые настройки аккаунта.</p> <p>Для получения подробной информации смотрите раздел <a href=\"accounts/permissions\">разрешения</a>.</p> ";
// Exports
export default code;